module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_1.3de5960f.jpg";